import type { ReportDetails } from "@memorang/types";

const fetchReport = async (_params: {
	sessionId: string;
	userId: string;
	numericId?: number;
}): Promise<ReportDetails> => {
	return {
		id: 0,
		numericId: 0,
		examName: "",
		accuracy: 0,
		score: 0,
		numQuestions: 0,
		numCorrect: 0,
		numIncorrect: 0,
		numSkipped: 0,
	} as ReportDetails;
};

export { fetchReport };
